import { NotificationPopup } from './NotificationPopup'
import { withNotificationPopup } from './withNotificationPopup'

const ConnectedNotificatinoPopup = withNotificationPopup(NotificationPopup)
export { ConnectedNotificatinoPopup as NotificationPopup }
